import moment from 'moment'
import { toYearWithDate } from './formatDate'

const getEndDate = (date, numOfDays = 0) => {
  if (numOfDays !== 0) {
    if (typeof date !== 'string') {
      const endDate = new Date(date)
      endDate.setDate(endDate.getDate() + Number(numOfDays))
      return moment(endDate).format('DD/MM/YYYY')
    }
    const selectedDate = toYearWithDate(date)
    const endDate = new Date(selectedDate)
    endDate.setDate(endDate.getDate() + Number(numOfDays))
    return moment(endDate).format('DD/MM/YYYY')
  }
  return ''
}

export default getEndDate
